import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { acrAPI } from "utils/api";
import { format } from "date-fns";
import { License } from "models/LicenseModel";
import { LICENSE_STATUS } from "../../ACRMonitor";
import { translate } from "i18n";

interface ILicenseInformationProps {
    technology: string;             
  }

export function LicenseInformation(licenseInformationProps: ILicenseInformationProps): React.ReactElement{

  const [licenseMessage, setLicenseMessage] = useState("");
  const [licenseValidity, setLicenseValidity] = useState("");


  useEffect(() => {
    const licenseInfoSub = acrAPI.licenseSubjects.get(licenseInformationProps.technology)?.subscribe(updateLicenseInformation);
    acrAPI.getLicenseStatusByTechno(licenseInformationProps.technology);
    return () => {licenseInfoSub?.unsubscribe}
  },[]);

  const updateLicenseInformation = (value: License): void => {
    let tmpMsg = "";
    if (value.status === LICENSE_STATUS.OK) {
      tmpMsg = "license ok";
    } else if (value.status === LICENSE_STATUS.WARNING) {
      tmpMsg = "license almost expired";
    } else if (value.status === LICENSE_STATUS.ERROR) {
      tmpMsg = "license invalid";
    }

    setLicenseMessage(translate(tmpMsg));
    if (value.expirationDate) {
      setLicenseValidity(`${translate("expiration date")}: ${format(
        new Date(value.expirationDate),
        "yyyy/MM/dd"
      )}`);
    }
    }
  
  return (
  <Box style={{ width: "50em" }}>
  {/* <Typography variant="h5">{translate("License information")}</Typography> */}
  <Typography variant="h6">
    <span data-cy=" license-status-label">{licenseMessage}.</span>
    {licenseValidity ? <span data-cy="expiration-date-label"> {licenseValidity}.</span> : <br />}
  </Typography>
  </Box>
  );

  }